export default {"src":"/_next/static/media/industrial-control-systems.8ce1e389.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};